import { IBroadcastEmailFrontEndModel } from "./types";

export function validator(values: IBroadcastEmailFrontEndModel) {
  const errors: any = {};

  if (!values.subject?.trim()) {
    errors.subject = "Subject is empty";
  } else {
    if (values.subject?.length < 3) {
      errors.subject = "Subject can't be shorter than 3 symbols";
    }

    if (values.subject?.length > 100) {
      errors.subject = "Subject can't be longer than 100 symbols";
    }
  }

  if (!values.title?.trim()) {
    errors.title = "Title is empty";
  } else {
    if (values.title?.length < 3) {
      errors.title = "Title can't be shorter than 3 symbols";
    }

    if (values.title?.length > 100) {
      errors.title = "Title can't be longer than 100 symbols";
    }
  }

  if (!values.content?.trim()) {
    errors.content = "Content is empty";
  } else {
    if (values.content?.length < 25) {
      errors.content = "Content can't be shorter than 25 symbols";
    }

    if (values.content?.length > 2000) {
      errors.content = "Content can't be longer than 100 symbols";
    }
  }

  return errors;
}
